import { db } from '@healthdesk/shared-services';
import firebase from 'firebase/compat/app';

export const DDX_CONTEXT_PROFILE_CONFIGS_COLLECTION = 'ddxContextProfileConfigs';

export const DDX_CONTEXT_PROFILE_IDS = Object.freeze({
  EMERGENCY_DEPARTMENT: 'emergency_department',
  PRIMARY_CARE: 'primary_care',
  URGENT_CARE: 'urgent_care',
});

const DEFAULT_BUNDLE = Object.freeze({
  includeTemporalHistory: false,
  includeExpectedButMissing: false,
  includeCalculatorResults: false,
  cantMissGrounding: 'minimal',
  clinicalViews: false,
  patientContextProfile: false,
  prevalenceCalibration: false,
});

const DEFAULT_SCORING = Object.freeze({
  prevalenceWeight: 0.3,
  edgeStrengthWeight: 1.0,
  stabilityThreshold: 'low',
});

const PROFILE_DEFAULTS = Object.freeze({
  [DDX_CONTEXT_PROFILE_IDS.EMERGENCY_DEPARTMENT]: {
    scoringParameters: { ...DEFAULT_SCORING },
    bundleComposition: { ...DEFAULT_BUNDLE },
  },
  [DDX_CONTEXT_PROFILE_IDS.PRIMARY_CARE]: {
    scoringParameters: {
      prevalenceWeight: 0.8,
      edgeStrengthWeight: 0.8,
      stabilityThreshold: 'high',
    },
    bundleComposition: { ...DEFAULT_BUNDLE, patientContextProfile: true, prevalenceCalibration: true },
  },
  [DDX_CONTEXT_PROFILE_IDS.URGENT_CARE]: {
    scoringParameters: {
      prevalenceWeight: 0.55,
      edgeStrengthWeight: 0.9,
      stabilityThreshold: 'moderate',
    },
    bundleComposition: { ...DEFAULT_BUNDLE, includeTemporalHistory: true },
  },
});

function getProfileDefault(profileId) {
  return PROFILE_DEFAULTS[profileId] || PROFILE_DEFAULTS[DDX_CONTEXT_PROFILE_IDS.EMERGENCY_DEPARTMENT];
}

class DdxContextProfileConfigService {
  async getConfig(contextProfileId) {
    const docRef = db.collection(DDX_CONTEXT_PROFILE_CONFIGS_COLLECTION).doc(contextProfileId);
    const doc = await docRef.get();
    const defaults = getProfileDefault(contextProfileId);
    if (!doc.exists) {
      return {
        contextProfileId,
        scoringParameters: { ...defaults.scoringParameters },
        bundleComposition: { ...defaults.bundleComposition },
        layer1PendingValidation: false,
      };
    }
    const data = doc.data() || {};
    return {
      contextProfileId,
      ...data,
      scoringParameters: {
        ...defaults.scoringParameters,
        ...(data.scoringParameters || {}),
      },
      bundleComposition: {
        ...defaults.bundleComposition,
        ...(data.bundleComposition || {}),
      },
      layer1PendingValidation: Boolean(data.layer1PendingValidation),
    };
  }

  async saveConfig(contextProfileId, config, updatedBy) {
    const docRef = db.collection(DDX_CONTEXT_PROFILE_CONFIGS_COLLECTION).doc(contextProfileId);
    const payload = {
      contextProfileId,
      scoringParameters: config.scoringParameters || {},
      bundleComposition: config.bundleComposition || {},
      lastBenchmarkRunId: config.lastBenchmarkRunId || null,
      lastBenchmarkScore:
        typeof config.lastBenchmarkScore === 'number' ? config.lastBenchmarkScore : null,
      lastBenchmarkPassedAt: config.lastBenchmarkPassedAt || null,
      layer1PendingValidation: Boolean(config.layer1PendingValidation),
      updatedBy: updatedBy || null,
      updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
    await docRef.set(payload, { merge: true });
    return this.getConfig(contextProfileId);
  }
}

export const ddxContextProfileConfigService = new DdxContextProfileConfigService();
export default ddxContextProfileConfigService;

